<template>
  <v-card style="padding:5px 0;margin:0 3px 5px 3px;">
    <v-img
      v-lazy:background-image=imageurl
      aspect-ratio=0.9
      :alt="food.name"
    ></v-img>
    <p style="text-align:left; padding:0 5px;margin-bottom:0">
      {{food.name | textTrim(10)}}
    </p>
  </v-card>
</template>

<script>
import getImageUrl from '@/assets/js/getImageUrl.js'

export default {
  name: 'FoodCardImage',
  data () {
    return {
    }
  },
  props: {
    food: Object
  },
  computed: {
    imageurl () {
      if (this.food.imageurl) return this.food.imageurl
      if (this.food.images[0]) {
        return getImageUrl.get('food_thumbs', this.food.id, this.food.images[0])
      }
      return '/img/noImage.png'
    }
  },
  filters: {
    textTrim: function (value, max) {
      if (value.length >= max) return value.substring(0, max - 1) + '...'
      return value
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
  },
  components: {
  }
}
</script>

<style>
</style>